import { Card, CardContent, CardHeader, CardTitle } from "@shared/components/ui/card";
import CityActions from "./CityActions";
import { Separator } from "@shared/components/ui/separator";
import { Badge } from "@shared/components/ui/badge";
import { useTranslation } from "react-i18next";

const CityCard = ({ city, showActions = true }) => {
  const { t } = useTranslation();
  return (
    <Card className="w-full">
      <CardHeader className="py-3">
        <div className="flex justify-between items-center">
          <CardTitle className="text-lg font-bold">
            {city.name} | {city.nameArabic}
          </CardTitle>

          {showActions && (
            <div className="flex gap-1">
              <CityActions mode="update" initialData={city} />
              <CityActions mode="delete" initialData={city} />
            </div>
          )}
        </div>
      </CardHeader>
      <CardContent className="pt-0">
        <div className="space-y-3">
          <div className="grid grid-cols-2 gap-2 text-sm">
            <div>
              <span className="text-gray-600 dark:text-gray-400">
                {t("common.deadline")}:
              </span>
              <div className="font-medium">{city.deadline}</div>
            </div>
            <div>
              <span className="text-gray-600 dark:text-gray-400">
                {t("common.fees.fixedFees")}:
              </span>
              <div className="font-medium">
                <Badge variant={city.isFeesFixed ? "default" : "secondary"}>
                  {city.isFeesFixed ? t("common.yes") : t("common.no")}
                </Badge>
              </div>
            </div>
          </div>

          <Separator />

          <div className="grid grid-cols-1 gap-2 text-sm">
            <div className="flex justify-between">
              <span className="text-gray-600 dark:text-gray-400">
                {t("common.fees.deliveryFees")}:
              </span>
              <span className="font-medium">
                {city.deliveryFees} {t("main.currency")}
              </span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600 dark:text-gray-400">
                {t("common.fees.refusalFees")}:
              </span>
              <span className="font-medium">
                {city.refusalFees} {t("main.currency")}
              </span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600 dark:text-gray-400">
                {t("common.fees.cancellationFees")}:
              </span>
              <span className="font-medium">
                {city.cancellationFees} {t("main.currency")}
              </span>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default CityCard;
